import { render, staticRenderFns } from "./SettingsCharts.vue?vue&type=template&id=6a0b26ca&"
import script from "./SettingsCharts.vue?vue&type=script&lang=ts&"
export * from "./SettingsCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports